@if (userLoaded()) {
    @if (wrongRegion(); as region) {
        <app-wrong-region [region]="region"></app-wrong-region>
    } @else {
        <div class="h-dvh w-dvw bg-shui-base-1 flex flex-col overflow-hidden">
            @if (showEnvironmentHint()) {
                <app-banner [stage]="stage"></app-banner>
            }
            <app-header></app-header>
            <div class="flex flex-1 min-h-0 overflow-hidden p-4 px-2 pt-0 pb-0 items-stretch">
                <app-country-switch class="hidden md:block" [(collapsed)]="sidebarCollapsed"></app-country-switch>
                <app-sidebar class="hidden md:block mr-2" [(collapsed)]="sidebarCollapsed"></app-sidebar>
                <main class="flex-1 min-w-0 overflow-y-auto min-h-0 box-border self-stretch">
                    <router-outlet></router-outlet>
                </main>
            </div>
            <div class="px-2 pb-4 pt-2 box-border">
                <app-footer></app-footer>
            </div>
        </div>
        <app-snackbar-container></app-snackbar-container>
    }
} @else {
    <div data-testid="emea-app-loading" class="h-dvh w-dvw bg-shui-base-1 flex items-center justify-center">
        <div class="flex flex-col items-center gap-8">
            <img
                src="assets/images/healthineers-logo/healthineers-logo-black.svg"
                alt="Siemens Healthineers"
                class="w-48 [html[theme='dark']_&]:hidden"
            />
            <img
                src="assets/images/healthineers-logo/healthineers-logo-white.svg"
                alt="Siemens Healthineers"
                class="w-48 hidden [html[theme='dark']_&]:block"
            />
            <sh-spinner size="s"></sh-spinner>
        </div>
    </div>
}
